"use strict";

exports.__esModule = true;

var _createBehaviorSubject = require("./createBehaviorSubject");

var _createBehaviorSubject2 = _interopRequireDefault(_createBehaviorSubject);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Generated by CoffeeScript 1.12.6
var toBehaviorSubject;

exports.default = toBehaviorSubject = function (priorObservable, opts) {
  var observable, sopts, subscription;
  subscription = void 0;
  observable = void 0;
  sopts = {
    onObserverStarted: function (observer, observers) {
      if (observers.length === 1) {
        subscription = priorObservable.subscribe({
          next: function (val) {
            return typeof observable.next === "function" ? observable.next(val) : void 0;
          },
          error: function (e) {
            if (subscription != null) {
              subscription.unsubscribe();
            }
            subscription = void 0;
            return typeof observable.error === "function" ? observable.error(e) : void 0;
          },
          complete: function () {
            if (subscription != null) {
              subscription.unsubscribe();
            }
            subscription = void 0;
            return typeof observable.complete === "function" ? observable.complete() : void 0;
          }
        });
      }
    },
    onObserversChanged: function (observers) {
      if (observers.length === 0) {
        if (subscription != null) {
          subscription.unsubscribe();
        }
        subscription = void 0;
      }
    }
  };
  if (opts != null ? opts.onlyWhen : void 0) {
    sopts.onlyWhen = opts.onlyWhen;
  }
  observable = (0, _createBehaviorSubject2.default)(sopts);
  return observable;
};